export default __webpack_public_path__ + "static/media/61t.b7fd9b81.jpg";